exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".markers {\n  background-color: #fff;\n  border: 1px solid #004336;\n  border-radius: 50%;\n  cursor: pointer;\n  height: 40px;\n  left: -20px;\n  padding: 10px;\n  position: absolute;\n  top: -20px;\n  width: 40px;\n}\n\n.markers .text {\n  align-items: center;\n  color: #333;\n  display: flex;\n  font-size: 14px ;\n  font-weight: bold;\n  justify-content: center;\n  text-align: center;\n}\n\n\n", ""]);

// exports
